module.exports = __webpack_public_path__ + "static/media/ne.d326b751.svg";